module.exports = __webpack_public_path__ + "img/close-green.625bcc0f.svg";